import React, {useState, useEffect} from "react"

import { URL } from "../config"

const Transactions = () => {
	const [transactions, setTransactions] = useState([])
	// console.log(transactions)
	// console.log(transactions.products["name"])

	useEffect( () => {
		fetch(`${URL}/transactions`, {
			headers: {
				"x-auth-token": localStorage.getItem('token')
			}
		})
		.then(res => res.json())
		.then(data => setTransactions(data))
	})

	const updateStatus = (statusId, transactionId) => {
		let body = {
			statusId
		}

		fetch(`${URL}/transactions/${transactionId}`, {
			method: "PUT",
			body: JSON.stringify(body),
			headers: {
				"Content-Type": "application/json",
				"x-auth-token": localStorage.getItem('token')
			}
		})
		.then(res => res.json())
		.then(data => {
			alert(data.message)
		})
	}

	return(
		<div className="transactions-background">
			<h2 className="py-5 text-light">Transactions</h2>
		<div className="container pb-5">
			{
				transactions.length ?

				<table className="table table-hover">
					<thead>
						<tr>
							<th>Transaction ID</th>
							<th>Tour</th>
							<th>Days</th>
							<th>Person</th>
							<th>Amount</th>
							<th>Payment</th>
							<th>Status</th>
							<th>Action/s</th>
						</tr>
					</thead>

					<tbody>
						{transactions.map(transaction => (
							<tr key={transaction._id}>
								<td>{transaction._id}</td>

								<td className="line-break">
								{ transaction.products.map(product => (
									product.name
								))}
								</td>

								<td className="line-break">
								{ transaction.products.map(product => (
									product.days
								))}
								</td>

								<td className="line-break">
								{ transaction.products.map(product => (
									product.quantity
								))}
								</td>

								<td>{transaction.total}</td>

								<td>{transaction.paymentMode}</td>

								<td>
									{ transaction.statusId === "5e9e4589ccb840ad756452be" ?
										"Pending" : (transaction.statusId === "5e9e45e2ccb840ad756452d9" ?
										"Reserved" : "Cancelled"
										)
									}
								</td>

								{ transaction.statusId === "5e9e4589ccb840ad756452be" ?
								<td>
									<button
										className="btn btn-success modifyButton mr-0 mr-lg-2"
										onClick={() => updateStatus("5e9e45e2ccb840ad756452d9", transaction._id)}
									>
										Reserve
									</button>

									<button 
										className="btn btn-danger modifyButton mt-2 mt-lg-0"
										onClick={() => updateStatus("5e9e45ffccb840ad756452e1", transaction._id)}
									>
										Cancel
									</button>
								</td> : null }
								
							</tr>
						))}
					</tbody>
				</table>

				: <h4 className="text-light">No transactions to show</h4>
			}
		</div>
		</div>
	)
}

export default Transactions